import request from './request'

// 获取角色列表
export function _roleIndex(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/role/index',
    })
    return request(config)
}

//获取栏目列表
export function _getColumnIndex(data = {}) {
    const config = Object.assign(data, {
      method: 'get',
      url: '/admin/column/index',
    })
    return request(config)
}

//编辑管理信息
export function _roleEdit(data = {}) {
    const config = Object.assign(data, {
      method: 'post',
      url: '/admin/role/edit',
    })
    return request(config)
}

//获取单个信息
export function _roleSingleInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/role/getinfo',
  })
  return request(config)
}

//角色删除
export function _removeRole(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/role/remove',
  })
  return request(config)
}

